import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb } from 'semantic-ui-react'

import { MainBodyContent } from 'components'
import { 
  bgCompanyLimitBankPath,
} from 'routes'
import { getCompanies } from 'ducks/options'
import { 
  getBGLimitOfBankDetail,
} from 'ducks/bgLimitOfBank'
import { getBankOwners } from 'ducks/bankGuarantee'
import InformationComponent from '../Shareds/Information'

const DetailBGLimitOfBank = (props) => {

  const { 
    valueForm, 
  } = props

  React.useEffect(() => {
    props.getBGLimitOfBankDetail(props.match.params.id, props.history)
    props.getCompanies()
    props.getBankOwners()
  }, [])

  return (
    <MainBodyContent 
      headerTitle='Limit of Bank - Detail'
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'LB', content: 'Limit of Bank', link: true, onClick: () => props.history.push(bgCompanyLimitBankPath) },
              { key: 'LBDetail', content: 'Detail', active: true }
            ]
          }
        />
      }
    >
      <InformationComponent/>
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const valueForm = getFormValues('formBGLimitOfBank')(state) || {}

  return ({
    valueForm,
    initialValues: {
      ...state.bgLimitOfBank.detail.data
    },
  })
}

const mapDispatchToProps = {
  getBGLimitOfBankDetail,
  getCompanies,
  getBankOwners
}

const ContForm = reduxForm({
  form: 'formBGLimitOfBank',
  enableReinitialize: true,
})(DetailBGLimitOfBank)

export default connect(mapStateToProps, mapDispatchToProps)(ContForm)
